import React from 'react';
import {
  Container,
  Typography,
  Box,
  Paper,
  Divider,
  Grid,
  Card,
  CardContent,
  CardHeader,
} from '@mui/material';
import { Science as ScienceIcon, BugReport as BugIcon } from '@mui/icons-material';
import ErrorHandlingExample from './core/ErrorHandlingExample';

const ExperimentalUI: React.FC = () => {
  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      {/* Header */}
      <Box sx={{ mb: 4, textAlign: 'center' }}>
        <Typography variant="h3" gutterBottom>
          🧪 Experimental UI Playground
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Test and experiment with new UI components, animations, and interactions
        </Typography>
      </Box>

      <Divider sx={{ my: 3 }} />

      {/* Error Handling Example Section */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <BugIcon color="primary" />
          Error Handling System
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          Test the comprehensive error handling system with error boundaries, Sentry integration, and user notifications.
        </Typography>

        <Card sx={{ mt: 2 }}>
          <CardHeader
            title="Error Handling Demo"
            subheader="Try triggering different types of errors to see how they're handled"
            sx={{ backgroundColor: 'background.paper' }}
          />
          <CardContent>
            <ErrorHandlingExample />
          </CardContent>
        </Card>
      </Box>

      <Divider sx={{ my: 3 }} />

      {/* Main Content Area */}
      <Paper sx={{ p: 4, textAlign: 'center', backgroundColor: 'background.paper' }}>
        <ScienceIcon sx={{ fontSize: 64, color: 'primary.main', mb: 2 }} />
        <Typography variant="h5" gutterBottom>
          Ready for Experiments
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          This space is ready for your UI experiments. Add new components and test them here.
        </Typography>
        <Typography variant="body2" color="text.secondary">
          The playground is intentionally kept simple to focus on individual experiments.
        </Typography>
      </Paper>

      {/* Future Experiments Section */}
      <Box sx={{ mt: 4 }}>
        <Typography variant="h6" gutterBottom>
          Planned Experiments
        </Typography>
        <Typography variant="body2" color="text.secondary">
          • Skeuomorphic button collection (2008-2011 Mac OSX style)<br />
          • Floating navigation elements<br />
          • Interactive form components<br />
          • Card layout systems<br />
          • Micro-interaction library
        </Typography>
      </Box>
    </Container>
  );
};

export default ExperimentalUI;
